import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=00f6ea84"
import script from "./PageNavigation.vue?vue&type=script&lang=js"
export * from "./PageNavigation.vue?vue&type=script&lang=js"
import style0 from "./PageNavigation.vue?vue&type=style&index=0&id=00f6ea84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports